<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">服务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的白名单</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">白名单列表</div>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn">
          域名白名单仅用于云服务器用户，其它用户无需申请！
        </div>
        <div class="ub-box z-margin-bottom-20-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="submitBmd">提交白名单</el-button>
          <div class="zj-select" style="margin-left: 25px">
            <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchBmd">
              <el-select v-model="key_type" slot="prepend" placeholder="全部">
                <el-option label="域名" value="domainname"></el-option>
                <el-option label="IP" value="ip"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="SearchBmd"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="bmdList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="domain" label="域名" align="left">
          </el-table-column>
          <el-table-column prop="set_time" label="添加时间" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="wzbah" label="网站备案号" :render-header="renderHeader" align="center">
          </el-table-column>
          <el-table-column prop="wzmc" label="网站名称" align="center">
          </el-table-column>
          <el-table-column prop="wzip" label="业务IP" align="center">
          </el-table-column>
          <el-table-column prop="caozuo" label="操作" align="center">
            <template slot-scope="scope">
              <span class="z-curPonit z-color-red" @click="BmdDel(scope.row.id)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        bmdList:[],
        listLoading:false,
        search:'',
        key_type:'domainname',
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchBmd()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async SearchBmd() {
        this.listLoading = true
        let data = 'cmd=bmd_list'+
          '&count='+ this.count +
          '&page='+ this.page +
          '&key_type='+ this.key_type +
          '&keyword='+ this.search
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount;
          this.bmdList = vueData.msg.content.map((item, index) => {
            return {
              id:item.id,
              domain:item.domain,
              set_time:item.set_time,
              wzbah:item.wzbah,
              wzmc:item.wzmc,
              wzip:item.wzip,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SearchState(domain) {
        let data = 'cmd=check_beian'+
          '&domainname='+ domain
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.bmdList.map((item, index) => {
            if(domain == item.domain){
              item.state = vueData.msg == 1 ? '已备案' : '未备案'
            }
          })
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      BmdDel(id) {
        MessageBox.confirm('您确定删除白名单么?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=bmd_del'+
            '&bmd_id=' + id
          this.dialogLoading = true
          let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.SearchBmd()}})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        })
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchBmd()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchBmd()
      },
      submitBmd(){
        this.$router.push('/fuwu4')
      },
      renderHeader(h, { column }) {
        return h(
          'span',
          [
            column.label,
            h(
              'a',
              {
                attrs: {
                  'href': '/help/index_263_1.html',
                  'class': 'dialog-help-link',
                  'target': '_blank'
                }
              }
            )
          ]
        );
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .state-icon {
    padding-left: 22px;
    background: no-repeat left center;
  }
  .server-state-run {
    background-image: url(../../assets/imgs/server_state_run.png);
    color: #29cc7a;
  }
  .server-state-paused {
    background-image: url(../../assets/imgs/server_state_paused.png);
    color: #ff3300;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/fuwu5.vue